import ConfirmDeleteModal from "./ConfirmDeleteModal";
export default ConfirmDeleteModal;
